<template>
  <div
    class="inner"
    :class="{ swiping: isSwiping }"
    :style="{ transform: `translateY(${translateY}px)` }"
  >
    <SwipeWrapper
      @pan-start="handleSwipeDownStart"
      @pan-move="handleSwipeMove"
      @pan-end="handleSwipeDownEnd"
    >
      <div class="swipe"></div>
    </SwipeWrapper>
    <div class="lines">
      <div class="line _active" />
      <div class="line" />
      <div class="line" />
      <div class="line" />
    </div>
    <div class="main-block">
      <h2>Сколько вас будет?</h2>
      <p class="message">
        Поможем найти идеальное место — от романтического ужина на двоих до
        весёлой встречи с друзьями.
      </p>
      <Counter v-model="currentVisitorsCount" :min-value="1" />
    </div>
    <div class="buttons">
      <div class="prev-button" v-if="screenWidth === 'mobile'">
        <IconArrowButton color="#ADADAD" />
      </div>
      <VButton @click="onNextClickHandler" class="button">
        <template v-if="screenWidth === 'mobile'" #rightAddon>
          <IconArrowButton color="#ffffff" />
        </template>
        <template #default>Далее</template>
      </VButton>
    </div>
    <IconPopupCross
      v-if="screenWidth !== 'mobile'"
      class="modal-cross"
      @click="closeModal"
    />
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import IconPopupCross from "@/components/icons/IconPopupCross.vue";
import Counter from "@/components/pages/client-booking/Counter.vue";
import IconArrowButton from "@/components/icons/IconArrowButton.vue";
import SwipeWrapper from "@/components/ui/SwipeWrapper.vue";

const store = useStore();

const screenWidth = computed(() => {
  return store.getters.screenType;
});
</script>

<script>
import VButton from "@/components/ui/VButton.vue";
import FilterDateModal from "@/components/modals/mapCateringFilter/FilterDateModal.vue";
export default {
  name: "FilterVisitorsModal",

  components: {
    VButton,
  },

  data() {
    return {
      currentVisitorsCount: 1,
      translateY: 0,
      isSwiping: false,
      threshold: 100,
    };
  },

  computed: {
    screenWidth() {
      return this.$store.getters.screenType;
    },
  },

  methods: {
    closeModal() {
      if (this.screenWidth === "mobile") {
        this.$store.dispatch("closeMobileModal");
      } else {
        this.$store.dispatch("closeModal");
      }
    },
    async onNextClickHandler() {
      this.$store.commit({
        type: "setFilterVisitors",
        value: this.currentVisitorsCount,
      });
      if (this.screenWidth === "mobile") {
        this.$store.dispatch("openMobileModal", {
          value: {
            component: FilterDateModal,
            props: {},
          },
        });
      } else {
        this.$store.dispatch("openModal", {
          value: {
            component: FilterDateModal,
            props: {},
          },
        });
      }
    },
    handleSwipeDownStart() {
      this.isSwiping = true;
    },
    handleSwipeDownEnd() {
      if (this.translateY > this.threshold) {
        this.closeModal();
      } else {
        this.translateY = 0;
        this.isSwiping = false;
      }
    },
    handleSwipeMove(event) {
      if (event.deltaY > 0) {
        this.translateY = event.deltaY;
      }
    },
  },

  mounted() {
    this.currentVisitorsCount =
      this.$store.state.clientRestaurants.filter.visitors || 2;
    this.$store.commit("setIsFilterShown");
  },
};
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  margin: 32px 0 0;
}

.main-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 162px;

  @include mobile {
    padding: 0 0 162px;
  }
}

.message {
  max-width: 528px;
  margin-top: 16px;
  margin-bottom: 120px;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: #858585;

  @include mobile {
    margin-top: 0;
    margin-bottom: 100px;
  }
}

.buttons {
  display: flex;
  justify-content: center;
  margin-top: 32px;
  width: 100%;
  gap: 16px;

  @include mobile {
    margin-top: auto;
  }
}

.button {
  height: 40px;
  width: 120px;
  padding: 9px 38px;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;

  @include mobile {
    width: 100%;
    border-radius: 100px;

    &:first-child {
      margin-bottom: 16px;
    }
  }
}
</style>

<style lang="scss" scoped>
.inner {
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: 776px;
  width: 640px;
  max-width: 640px;
  margin: auto;
  padding: 32px 56px 40px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;

  @media screen and (max-width: 841px) {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    max-width: 100%;
    box-shadow: 0 -2px 10px 0 #0000000d;
    border-radius: 20px 20px 0 0;
    padding: 40px 16px 24px 16px;
    min-height: 632px;
    max-height: 632px;
    height: 632px;
  }

  &.swiping {
    transition: none;
  }
}

h2 {
  text-align: center;
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;

  @include mobile {
    margin-bottom: 16px;
  }
}

.modal-cross {
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
}

.timers {
  max-width: 776px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;

  > div {
    width: calc(50% - 8px);
  }
}

.lines {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 64px;
  gap: 10px;

  @include mobile {
    width: 100%;
    height: 8px;
    justify-content: flex-start;
    align-items: center;
    margin: 0 0 32px;
    padding: 0 4px;
    border-radius: 8px;
    background-color: white;
  }
}

.line {
  width: 122px;
  height: 8px;
  border-radius: 8px;
  background-color: #adadad;

  @include mobile {
    width: calc(25% - 4px);
    border-radius: 8px;
  }

  &._active {
    background-color: #f18e35;
    cursor: pointer;
  }
}

.prev-button {
  display: flex;
  flex: 0 0 auto;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid #adadad;
  cursor: pointer;

  svg {
    width: 24px;
    height: 24px;
    transform: rotate(180deg);
  }
}

.swipe {
  display: none;

  @include mobile {
    display: block;
    position: absolute;
    width: 100%;
    height: 20px;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 16px 16px 0 0;
    background-color: #ffffff;

    &::before {
      content: "";
      left: 50%;
      position: absolute;
      top: 6px;
      transform: translate(-50%);
      width: 36px;
      height: 6px;
      border-radius: 4px;
      background-color: #d6d6d6;
    }
  }
}
</style>
